import {Map, fromJS, List} from "immutable";

import {
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_REQUEST,
    GET_PRODUCTS_ERROR,
    GET_PRODUCT_REQUEST,
    GET_PRODUCT_SUCCESS,
    GET_PRODUCT_ERROR,
    CREATE_PRODUCT_REQUEST,
    CREATE_PRODUCT_SUCCESS,
    CREATE_PRODUCT_ERROR,
    UPDATE_PRODUCT_REQUEST,
    UPDATE_PRODUCT_SUCCESS,
    UPDATE_PRODUCT_ERROR,
    CHANGE_STATUS_PRODUCT_REQUEST,
    CHANGE_STATUS_PRODUCT_SUCCESS,
    CHANGE_STATUS_PRODUCT_ERROR,
    DELETE_PRODUCT_REQUEST,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_ERROR,
    CLEAN_PRODUCTS
} from '../actions/products';

const products = (state = Map({
  payload: List([]),
  isFetching: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_PRODUCTS_REQUEST:
      case GET_PRODUCT_REQUEST:
      case CREATE_PRODUCT_REQUEST:
      case UPDATE_PRODUCT_REQUEST:
      case CHANGE_STATUS_PRODUCT_REQUEST:
      case DELETE_PRODUCT_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Success
      case GET_PRODUCTS_SUCCESS:
      case GET_PRODUCT_SUCCESS:
      case CLEAN_PRODUCTS:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_PRODUCT_SUCCESS:

          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              updatedPayload = payload.push(fromJS(action.payload));

              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_PRODUCT_SUCCESS:
      case CHANGE_STATUS_PRODUCT_SUCCESS:

          // Check if payload is a List (Array)
          if(List.isList(payload)) {

              // Find the index of the product to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });

              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }


              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;

      case DELETE_PRODUCT_SUCCESS:
          updatedPayload = payload.filter( product => {
              return product.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_PRODUCTS_ERROR:
      case GET_PRODUCT_ERROR:
      case CREATE_PRODUCT_ERROR:
      case UPDATE_PRODUCT_ERROR:
      case CHANGE_STATUS_PRODUCT_ERROR:
      case DELETE_PRODUCT_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default products;



// WEBPACK FOOTER //
// ./src/reducers/products.js